
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class OpenLocker extends Vue {

  private loading: boolean = false;
  private lockersystem: number = null;
  private lockercell: number = null;

  private async openLocker(): Promise<void> {
    if (window.confirm(`${this.$t("sav.openLocker.confirm")} ${this.lockersystem}-${this.lockercell}`)) {
      this.loading = true;
      await this.$store.dispatch("connectorConnectedBoxes/openLockercell", {
        lockersystem: this.lockersystem,
        lockercell: this.lockercell,
      }).then(() => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$t("sav.openLocker.success"),
      });
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loading = false;
    });
    }
  }
}
